import {Stream} from './stream';
import {Item} from './item';
import {History} from './history';
import {StageChange} from './stagechange';
import {FieldsChange} from './fieldschange';
import {Editor} from './editor';
import {CommentEditor} from './commenteditor';

/**
 * @memberOf BX.UI
 */
export const Timeline = {
	Stream,
	Item,
	History,
	StageChange,
	Editor,
	CommentEditor,
	FieldsChange,
};